const {
  mcuFields,
  sbcFields,
  mainMcuFields,
  mainSbcFields,
} = require("./constants");

const slugify = function(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

const truncateString = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

const getSearchResults = query => {
  const index = window.__FLEXSEARCH__.en.index;
  const store = window.__FLEXSEARCH__.en.store;
  if (!query || !index) {
    return [];
  } else {
    let results = [];
    Object.keys(index).forEach(key => {
      results.push(...index[key].values.search(query));
    });

    results = Array.from(new Set(results));

    const nodes = store
      .filter(node => (results.includes(node.id) ? node : null))
      .map(node => node.node);

    return nodes;
  }
};

const getFrontmatter = category => {
  switch (category) {
    case "microcontroller":
      return "mcuFrontmatter";
    case "single-board-computer":
      return "sbcFrontmatter";
    default:
      return "";
  }
};

const getLocalSearchQuery = category => {
  switch (category) {
    case "microcontroller":
      return "mcuLocalSearch";
    case "single-board-computer":
      return "sbcLocalSearch";
    default:
      return "";
  }
};

const getFields = category => {
  switch (category) {
    case "microcontroller":
      return mcuFields;
    case "single-board-computer":
      return sbcFields;
    default:
      return {};
  }
};

const getMainFields = category => {
  switch (category) {
    case "microcontroller":
      return mainMcuFields;
    case "single-board-computer":
      return mainSbcFields;
    default:
      return {};
  }
};

module.exports = {
  slugify,
  getSearchResults,
  truncateString,
  getFrontmatter,
  getFields,
  getMainFields,
  getLocalSearchQuery,
};
